module.exports = __webpack_public_path__ + "img/404_768.1049d5d4.png";